import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';

import { toggleArea, togglePrice } from './../actions';

import {priceList} from './elements/helper'
import './FilterBar.css';

class FilterBar extends Component {

	render() {

		const toggleAreaFnc = function(e){
			this.props.dispatch(toggleArea(e.target.value))
		}.bind(this)

		const togglePriceFnc = function(e){
			this.props.dispatch(togglePrice( Number(e.target.value) ))
		}.bind(this)

		const prices = this.props.prices;
		const priceSelected = function(price){
			if (this.props.pricesSelected === null) return '';
			return (this.props.pricesSelected.indexOf(price) > -1) ? 'select' : 'deselect' ; 
		}.bind(this);

		const priceItems = prices.map((price, i) =>
			<li key={i}>
				<button type="button" onClick={togglePriceFnc} value={price} className={priceSelected(price)} >
					{priceList(price)}
				</button>
			</li>
		);

		const areas = this.props.areas;
		const areaSelected = function(area){
			if (this.props.areasSelected === null) return '';
			return (this.props.areasSelected.indexOf(area) > -1) ? 'select' : 'deselect' ; 
		}.bind(this);

		const areaItems = areas.map((area, i) =>
			<li key={i}>
				<button type="button" onClick={toggleAreaFnc} value={area} className={areaSelected(area)} >
					{area}
				</button>
			</li>
		);

		return (
			<div className='FilterBar'>
				<Grid fluid>
					<Row>
						<Col xs={12} md={6}>
							<ul>
							{areaItems}
							</ul>
						</	Col>
						<Col xs={12} md={6}>
							<ul>
							{priceItems}
							</ul>
						</Col>
					</Row>
				</Grid>				
			</div>
		);
	}
}


const mainProps = state => {
	return {
		areas: state.main.areas,
		prices : state.main.prices,
		areasSelected: state.main.areasSelected,
		pricesSelected : state.main.pricesSelected,
	}
}
	
export default connect(mainProps)(FilterBar);





// WEBPACK FOOTER //
// ./src/components/FilterBar.js